function createWithholdingStatement(docType, enumValue) {
  return Object.freeze({
    name: docType.toLowerCase(),
    enumValue
  });
}

export const simpleWhdStatement = createWithholdingStatement('SimpleWhdStatement', 47);
export const detailedWhdStatement = createWithholdingStatement('DetailedWhdStatement', 48);
export const altWhdStatement = createWithholdingStatement('AltWhdStatement', 49);
export const pooledWhdStatement = createWithholdingStatement('PooledWhdStatement', 50);

export const whdStatementDocTypes = Object.freeze([
  simpleWhdStatement,
  detailedWhdStatement,
  altWhdStatement,
  pooledWhdStatement
]);

export function getWhdStatementByName(name) {
  return whdStatementDocTypes.find(dt => dt.name === name?.toLowerCase());
}

export function getWhdStatementByEnumValue(enumValue) {
  return whdStatementDocTypes.find(dt => dt.enumValue === enumValue);
}
